import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

import { cn } from '@base/lib/utils';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & { variant?: 'default' | 'purple' }
>(({ className, variant = 'default', ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track
      className={classNames(
        'relative h-[6px] w-full grow overflow-hidden rounded-full',
        setupForDark('bg-border-primary'),
        'cursor-pointer'
      )}
    >
      <SliderPrimitive.Range
        className={classNames(
          'absolute h-full',
          variant === 'purple' ? setupForDark('bg-violet-700') : setupForDark('bg-text-primary')
        )}
      />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className={classNames(
        'block h-[20px] w-[20px] rounded-full',
        'border-[2px]',
        'shadow transition-colors ',
        'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-neutral-300',
        'disabled:pointer-events-none disabled:opacity-50',
        'cursor-pointer',
        variant === 'purple'
          ? setupForDark('border-bg-primary bg-violet-700')
          : setupForDark('border-neutral-50 bg-text-primary')
      )}
    />
  </SliderPrimitive.Root>
));

Slider.displayName = SliderPrimitive.Root.displayName;

Slider.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'purple'])
};

export { Slider };
